import templateUrl from './publications-documents-milepost-archive.html';
import clone from 'lodash/clone';

export const publicationsDocumentsMilepostArchiveComponent = {
	templateUrl,

	bindings: {
		slugUrl: '@'
	},

	controller: class PublicationsDocumentsMilepostArchiveComponent {
		constructor(MilepostArchiveService, $anchorScroll) {
			'ngInject';

			this.milepostArchiveService = MilepostArchiveService;
			this.$anchorScroll = $anchorScroll;
		}

		$onInit() {
			this.details = {};
			this.isPaginationEnabled = true;
			this.paginationDetails = {
				currentPage: 1,
				itemPerPage: 10,
				totalItems: 0
			};

			this.filterDetails = {
				'limit': this.paginationDetails.itemPerPage,
				'pageId': this.paginationDetails.currentPage
			};

			this._filterMilepost();
		}

		onChange(pageNumber) {
			this.paginationDetails.currentPage = pageNumber;
			this.filterDetails.limit = this.paginationDetails.itemPerPage;
			this.filterDetails.pageId = this.paginationDetails.currentPage;
			this._filterMilepost();
		}

		_filterMilepost() {
			this.milepostArchiveService.getMilepostArchiveReportFilterDetails(this.filterDetails, this.slugUrl)
				.then(({ details, count }) => {
					this.details.details = details;
					this.paginationDetails.totalItems = count || this.paginationDetails.totalItems;
					this.paginationDetails = clone(this.paginationDetails);
					this.$anchorScroll(() => $location.hash());
				});
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/publications-documents-milepost-archive/publications-documents-milepost-archive.component.js